import React, { useEffect } from "react";
import Components from "./components/Components";
import ScrolToTop from "./components/Elements/ScrolToTop";
import { preloadRecaptcha } from "./utils/recaptcha";
//import Loader from "./components/Elements/Loader";


const App = () => {
  useEffect(() => {
    preloadRecaptcha();
  }, []);

  return (
    <div className="App">
      
      <Components />
      <ScrolToTop />
      
    </div>
  );
};
export default App;
